// extracted by mini-css-extract-plugin
export default {"productGallery":"Or-z","infoAboveGallery":"Pr-z","inQuickShop":"Qr-z"};